import React from "react";
import { Container, Row, Col } from "reactstrap";
//Import Images

import error from "../../../assets/images/error-img.png";

export const RestrictedPage = () => {
  return (
    <div className="my-5 pt-5">
      <Container>
        <Row>
          <Col lg="12">
            <div className="text-center">
              <Row className="justify-content-center mt-5">
                <Col sm="4" className="pt-5">
                  <div className="maintenance-img">
                    <img
                      src={error}
                      alt=""
                      className="img-fluid mx-auto d-block"
                    />
                  </div>
                </Col>
              </Row>
              <h4 className="mt-5">Not Authorized</h4>
              <p className="text-muted">
                Oops, you do not have the required permission to view this page!
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
